/**
 * useTagColorSync Hook
 *
 * Automatically syncs tag colors from API to global cache.
 * This ensures TagNode (in editor) and LexicalContent (in memos) always show current colors.
 *
 * Call this hook once in your app root or in components that render tags.
 */

import { useEffect } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { updateTagColorCache } from "@/services/TagService";
import { useTags } from "./useTagQueries";

export function useTagColorSync() {
  const { currentUser } = useAuth();

  // Fetch tags from API only when user is logged in
  // React Query handles caching/refetching
  const { data: tags = [] } = useTags({
    enabled: !!currentUser, // Only fetch when user is logged in
  });

  // Update global cache when API data changes
  useEffect(() => {
    if (tags.length > 0) {
      updateTagColorCache(tags);
    }
  }, [tags]);
}
